import type { EvHistoricalPositionsResponseModel } from "@/features/ev/api/useEvItemHistoricalPositions";
import dayjs from "dayjs";

export interface EvHistoricalPricingChartRecord {
	date: string;
	estimatedValue: number;
	marketPrice: number;
}

export const getEvHistoricalPricingChartData = (evHistoricalPositionsResponseModel: EvHistoricalPositionsResponseModel[]): EvHistoricalPricingChartRecord[] => {
	return evHistoricalPositionsResponseModel
		.map(value => ({
			date: dayjs(value.date).format("DD MMM YYYY"),
			estimatedValue: value.estimatedValue,
			marketPrice: value.marketPrice
		}))
		.sort((a, b) => dayjs(a.date).diff(dayjs(b.date)));
};
